// The routed queue's views, picked from a filter button beside the search; Sentinels only, while routing is on.

import { Check, ListFilter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { PANEL, ROW, ROW_HOVER, ROW_INNER, ROW_SELECTED } from '@/components/layouts/menu-styles';
import { SENTINEL_SECTIONS, useSentinelRouting } from '@/hooks/use-sentinel-routing';
import { cn } from '@/lib/utils';

/** A Sentinel's list opens on their own tickets, so only another view marks the button. */
const DEFAULT_SECTION = 'mine';

export function SentinelTicketSections() {
  const routing = useSentinelRouting();
  if (!routing.routingEnabled || routing.section === null || !routing.isSentinel) return null;
  const current = routing.section;
  const filtered = current !== DEFAULT_SECTION;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={`Ticket view: ${SENTINEL_SECTIONS[current]}`}
          title={`Showing ${SENTINEL_SECTIONS[current]}`}
          className="relative shrink-0 text-gray-900"
        >
          <ListFilter className="size-[14px]" />
          {filtered && <span aria-hidden className="absolute right-1 top-1 size-1.5 rounded-full bg-accent-purple" />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={6} aria-label="Ticket view" className={cn(PANEL, 'w-[200px] min-w-0')}>
        {routing.sections.map((section) => {
          const selected = section === current;
          return (
            <DropdownMenuItem
              key={section}
              onSelect={() => routing.setSection(section)}
              className={cn(ROW, ROW_HOVER, selected && ROW_SELECTED)}
            >
              <span className={ROW_INNER}>
                <span className="flex-1">{SENTINEL_SECTIONS[section]}</span>
                {selected && <Check className="size-[14px] shrink-0" />}
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
